import { queryOptions } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { useAppSelector } from "../../../redux/hooks";

export const useTagsQueryOptions = (params?: {
  type?: string;
  origin?: string;
  entity_type?: "PRODUCT" | "ADVERTISEMENT" | "ORGANIZATION" | "KEYWORD-TARGET" | "AUDIENCE" | "PRICING_PLAN";
}) => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);

  return queryOptions({
    queryKey: ["tags", marketPlace, params],
    queryFn: async () => {
      return await apiClient.getTags({
        queries: {
          marketplace: marketPlace,
          ...params,
        },
      });
    },
  });
};
